/**
 * How long every dialog takes to animate in and to animate out. PrimeReact removes a
 * centred dialog after 150 ms by default, which cut the closing animation short; the
 * transitions in AppDialog.module.scss run for the same 250 ms.
 */
export const DIALOG_TRANSITION_MS = 250;

export const dialogTransitionOptions = {
  timeout: { enter: DIALOG_TRANSITION_MS, exit: DIALOG_TRANSITION_MS },
};
